import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  SetMonthBudgetPayload,
  SetMonthIncomePayload,
  SetPrevPeriodResiduePayload
} from 'common/types';
import {
  BudgetMonthBase
} from '../../../common/entities';
import axios from '../../api/axiosClient';
import { endpoints } from '../../api/endpoints';
import { getUserData } from './userData.actions';

export const setBudgetMonth = createAsyncThunk(
  'budgetMonth/set',
  async (payload: BudgetMonthBase, thunkAPI) => {
    try {
      const response = await axios.post(
        `${endpoints.budgetMonth.all}`,
        payload
      );
      thunkAPI.dispatch(getUserData());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);

export const setMonthIncome = createAsyncThunk(
  'budgetMonth/income/set',
  async (payload: SetMonthIncomePayload, thunkAPI) => {
    try {
      const response = await axios.post(
        `${endpoints.budgetMonth.income}`,
        payload
      );
      thunkAPI.dispatch(getUserData());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);

export const setMonthBudget = createAsyncThunk(
  'budgetMonth/budget/set',
  async (payload: SetMonthBudgetPayload, thunkAPI) => {
    try {
      const response = await axios.post(
        `${endpoints.budgetMonth.budget}`,
        payload
      );
      thunkAPI.dispatch(getUserData());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);

export const setPrevPeriodResidue = createAsyncThunk(
  'budgetMonth/residue/set',
  async (payload: SetPrevPeriodResiduePayload, thunkAPI) => {
    try {
      const response = await axios.post(
        `${endpoints.budgetMonth.residue}`,
        payload
      );
      thunkAPI.dispatch(getUserData());
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data?.message);
    }
  }
);
